export default __webpack_public_path__ + "static/media/dashvaluate.769a5e6d.png";